/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ fundName: NonNullable<unknown> }} Usermanagement_Permissions_Modalremoveaccess3Inputs */

const en_usermanagement_permissions_modalremoveaccess3 = /** @type {(inputs: Usermanagement_Permissions_Modalremoveaccess3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove access to ${i?.fundName}`)
};

/**
* | output |
* | --- |
* | "Remove access to {fundName}" |
*
* @param {Usermanagement_Permissions_Modalremoveaccess3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const usermanagement_permissions_modalremoveaccess3 = /** @type {((inputs: Usermanagement_Permissions_Modalremoveaccess3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usermanagement_Permissions_Modalremoveaccess3Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_usermanagement_permissions_modalremoveaccess3(inputs)
});
export { usermanagement_permissions_modalremoveaccess3 as "userManagement_permissions_modalRemoveAccess" }